import fetch from "@lib/fetch";
import { API } from "../../config";

export const getOrders = (params,token) => {
    return fetch(`${API}/v1/analytics/orders?${params}`,{
      mode: 'cors',
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      return response.json()
    })
    .catch(error => {
      console.log(error);
    })
  }

export const getRatesUsage = (params,token) => {
    return fetch(`${API}/v1/analytics/rates/couriers?${params}`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    });
}